import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { Await } from '@warp-drive/ember';

export class IfCoachee extends Component<{
  Blocks: {
    isCoachee?: [];
    notCoachee?: [];
  };
}> {
  @service declare coachee: CoacheeService;

  get isCoachee(): Promise<boolean> {
    return this.coachee.isCoachee();
  }

  <template>
    <Await @promise={{this.isCoachee}}>
      <:success as |status|>
        {{#if status}}
          {{yield to="isCoachee"}}
        {{else}}
          {{yield to="notCoachee"}}
        {{/if}}
      </:success>
      <:error>
        {{yield to="notCoachee"}}
      </:error>
    </Await>
  </template>
}
